import { useEffect, useState } from 'react';
import { convertStatic } from 'react-html-converter/browser';
import { Templates } from '../api/services/next';
import { Languages } from '../components/shared/constants';
import { useMessageResources } from '../language'

const useTemplate = ({ templateId = null, languageId = null, templateTypeId = null }) => {
  const message = useMessageResources();
  if (!(templateTypeId || templateId)) {
    throw new Error(message("EitherTemplateIdOrACombinationOfLanguageIdAndTemplateTypeIdIsRequired"));
  }

  const [template, setTemplate] = useState({});

  useEffect(() => {
    try {
      (async () => {
        let [template] = await Templates.GetTemplates({
          Id: templateId,
          LanguageId: languageId,
          TemplateTypeId: templateTypeId,
        });
        if (!template) // if template was not found with guest's language, try getting template in english as default
          [template] = await Templates.GetTemplates({
            Id: templateId,
            LanguageId: Languages.English.ID,
            TemplateTypeId: templateTypeId,
          });
        setTemplate(template);
      })();
    } catch (error) {
      throw new Error(error);
    }
  }, [templateId, languageId, templateTypeId]);

  return {
    body: convertStatic(template?.HtmlContent),
    subject: template?.Subject,
  };
};

export default useTemplate;
